__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "@iwt-core-web/branded-shell";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@aviv-csnt/react", "3.1.0", () => (() => (__webpack_require__(7114))), 1);
			register("@aviv-dxp/react-thor", "2.25.9", () => (() => (__webpack_require__(1069))), 1);
			register("@aviv-trak/feature-flagging", "1.5.4", () => (() => (__webpack_require__(2932))), 1);
			register("@aviv-unified-frontend/runtime/authentication", "11.1.0", () => (() => (__webpack_require__(5301))), 1);
			register("@aviv-unified-frontend/runtime/brand", "11.1.0", () => (() => (__webpack_require__(6162))), 1);
			register("@aviv-unified-frontend/runtime/environment", "11.1.0", () => (() => (__webpack_require__(6210))), 1);
			register("@aviv-unified-frontend/runtime/fetcher", "11.1.0", () => (() => (__webpack_require__(9556))), 1);
			register("@aviv-unified-frontend/runtime/head", "11.1.0", () => (() => (__webpack_require__(9195))), 1);
			register("@aviv-unified-frontend/runtime/i18n", "11.1.0", () => (() => (__webpack_require__(8921))), 1);
			register("@aviv-unified-frontend/runtime/lifecycle", "11.1.0", () => (() => (__webpack_require__(2245))), 1);
			register("@aviv-unified-frontend/runtime/monitoring", "11.1.0", () => (() => (__webpack_require__(531))), 1);
			register("@aviv-unified-frontend/runtime/router", "11.1.0", () => (() => (__webpack_require__(7246))), 1);
			register("@gemini/core", "3.7.0", () => (() => (__webpack_require__(509))), 1);
			register("@iwt-core-web/avo", "0.1.0", () => (() => (__webpack_require__(290))), 1);
			register("@iwt-core-web/consent-react", "3.0.0", () => (() => (__webpack_require__(4790))), 1);
			register("@iwt-core-web/design-system-core", "1.0.0", () => (() => (__webpack_require__(2421))), 1);
			register("@iwt-core-web/feature-flagging", "1.4.0", () => (() => (__webpack_require__(4332))), 1);
			register("@iwt-core-web/runtime/authentication", "1.1.1", () => (() => (__webpack_require__(1165))), 1);
			register("@iwt-core-web/runtime/brand", "1.1.1", () => (() => (__webpack_require__(7914))), 1);
			register("@iwt-core-web/runtime/environment", "1.1.1", () => (() => (__webpack_require__(9434))), 1);
			register("@iwt-core-web/runtime/fetcher", "1.1.1", () => (() => (__webpack_require__(604))), 1);
			register("@iwt-core-web/runtime/head", "1.1.1", () => (() => (__webpack_require__(9491))), 1);
			register("@iwt-core-web/runtime/i18n", "1.1.1", () => (() => (__webpack_require__(2577))), 1);
			register("@iwt-core-web/runtime/lifecycle", "1.1.1", () => (() => (__webpack_require__(8221))), 1);
			register("@iwt-core-web/runtime/monitoring", "1.1.1", () => (() => (__webpack_require__(4043))), 1);
			register("@iwt-core-web/runtime/router", "1.1.1", () => (() => (__webpack_require__(854))), 1);
			register("@iwt-core-web/tracking", "2.0.1", () => (() => (__webpack_require__(6253))), 1);
			register("@react-aria/focus", "3.22.0", () => (() => (__webpack_require__(7453))), 1);
			register("@react-aria/i18n", "3.13.0", () => (() => (__webpack_require__(5976))), 1);
			register("@react-aria/interactions", "3.28.0", () => (() => (__webpack_require__(6080))), 1);
			register("@react-aria/overlays", "3.32.0", () => (() => (__webpack_require__(8408))), 1);
			register("@react-aria/ssr", "3.10.0", () => (() => (__webpack_require__(8860))), 1);
			register("@react-aria/toast", "3.1.0", () => (() => (__webpack_require__(3464))), 1);
			register("@react-aria/utils", "3.34.0", () => (() => (__webpack_require__(8841))), 1);
			register("@react-stately/overlays", "3.7.0", () => (() => (__webpack_require__(4160))), 1);
			register("@react-stately/toast", "3.2.0", () => (() => (__webpack_require__(3106))), 1);
			register("react-dom/client", "19.2.8", () => (() => (__webpack_require__(9083))), 1);
			register("react-dom/server", "19.2.8", () => (() => (__webpack_require__(6593))), 1);
			register("react-dom", "19.2.8", () => (() => (__webpack_require__(2450))), 1);
			register("react/jsx-runtime", "19.2.8", () => (() => (__webpack_require__(4558))), 1);
			register("react", "19.2.8", () => (() => (__webpack_require__(1102))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};